import React from 'react';

function Intro({ lang, setLang, nextStep}) {
  return (
    <>
    <meta charSet="utf-8" />
    <title>Bluefire</title>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="images/favicon/apple-touch-icon.webp"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="32x32"
      href="images/favicon/favicon-32x32.webp"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="16x16"
      href="images/favicon/favicon-16x16.webp"
    />
    <link rel="manifest" href="images/favicon/site.webmanifest" />
    <link
      rel="mask-icon"
      href="images/favicon/safari-pinned-tab.svg"
      color="#0047bb"
    />
    <link rel="shortcut icon" href="images/favicon/favicon.ico" />
    <meta name="msapplication-TileColor" content="#0047bb" />
    <meta
      name="msapplication-config"
      content="images/favicon/browserconfig.xml"
    />
    <meta name="theme-color" content="#ffffff" />
    <link
      rel="preload"
      as="font"
      href="fonts/Lato-Regular.woff2"
      type="font/woff2"
      crossOrigin=""
    />
    <link
      rel="preload"
      as="font"
      href="fonts/Lato-Light.woff2"
      type="font/woff2"
      crossOrigin=""
    />
    <link
      rel="preload"
      as="font"
      href="fonts/Lato-Bold.woff2"
      type="font/woff2"
      crossOrigin=""
    />
    <link
      rel="preload"
      as="font"
      href="fonts/Lato-SemiBold.woff2"
      type="font/woff2"
      crossOrigin=""
    />
    <link rel="stylesheet" href="css/main.css" />
    {/*include ../components/site-header*/}
    <main className="c-main-content c-main-content--intro">
      <div className="c-page-intro">
        <div className="c-page-intro__content">
          <a
            className="c-page-intro__logo-link"
            href="./"
            aria-label="Go to home page"
          >
            <img
              className="c-page-intro__logo"
              src="images/components/site-header/logo-blf-specialty.svg"
              alt="Bluefire Specialty Logo"
              width={180}
              height={61}
            />
          </a>
          <h1 className="c-page-intro__title">
            {lang === 'eng' ? 'Application ' : 'Solicitud'}<br />
          {lang === 'eng' ? 'for Bus Insurance' : ' para Seguro de Autobuses'}
          </h1>


          <div className="c-page-intro__language">
            <button 
              className={`c-quote__control c-button ${lang === 'eng' ? 'c-button__active' : ''}`} 
              type="button"
              onClick={() => setLang('eng')}
            >
              <span className="o-icon">
                <svg aria-hidden="true" focusable="false" role="img">
                  <use href="images/icons/icons.svg#icon-language" />
                </svg>
              </span>
              English
            </button>
            <button 
              className={`c-quote__control c-button ${lang === 'esp' ? 'c-button__active' : ''}`} 
              type="button"
              onClick={() => setLang('esp')}
            >
              <span className="o-icon">
                <svg aria-hidden="true" focusable="false" role="img">
                  <use href="images/icons/icons.svg#icon-language" />
                </svg>
              </span>
              Spanish
            </button>
          </div>

          <div className="c-page-intro__control">
            <button
              className="c-quote__control c-button c-button--blue-light"
              type="button"
              onClick={nextStep}
            >
              {lang === 'eng' ? 'Start Quote' : 'Comenzar la cotización'}
            </button>
          </div>
            
        </div>
        
        <picture className="c-page-intro__pic">
  <source media="(min-width: 700px)" srcSet="images/components/banner-lg.jpg 1x, images/components/banner,@2x.jpg 2x" type="image/jpg" />
  <source srcSet="images/components/banner-sm.jpg 1x, images/components/banner-sm@2x.jpg 2x" type="image/jpg" />
  <img className="c-page-intro__img" src="images/components/banner-lg.jpg" alt="" width={360} height={615} />
</picture>
      </div>
    </main>
    <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On  <br/></> : <>Listado de entidades/números de licencia por estado <br /> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
  </>
  
  );
}

export default Intro;
